var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.sign)?[_vm._v(_vm._s(_vm.formattedSign)+" ")]:_vm._e(),_vm._v(_vm._s(_vm.formatted)+" "+_vm._s(_vm.currency))],2)
}
var staticRenderFns = []

export { render, staticRenderFns }